import React from 'react';
import BadGateway from 'app/components/pages/BadGateway';
import ContentSpinner from 'app/components/presentation/loading/ContentSpinner';
import makeLazyLoadingWrapper from 'app/components/mixins/makeLazyLoadingWrapper';
import Page from 'app/components/layout/Page';
import { useI18n } from 'app/components/localization';
import { PageVariant } from 'app/components/layout/Page/PageLayout';
import { useBrand } from 'app/components/OrganizationContext';

const LoadingComponent = () => {
  const { t } = useI18n();
  const brand = useBrand();
  // The first party flag is used here because customization of word pages will only ever
  // happen with the DMM brand.
  const title = brand.firstPartyDmm ? t('uknow.japan.brand') : t('uknow.global.brand');
  return (
    <Page
      title={title}
      description={t('uknow.page.description')}
      variant={PageVariant.Wide}
      header={null}
      footer={null}
    >
      <ContentSpinner />
    </Page>
  );
};

const wrapComponent = makeLazyLoadingWrapper({
  LoadingComponent,
  ErrorComponent: BadGateway,
});

export default <T extends React.ComponentType<any>>(
  getModule: () => Promise<{ default: T }>,
) => wrapComponent(
  async () => (await getModule()).default,
);
